import React from 'react';

export default function ToggleSwitch({ checked, onChange, onLabel = 'Published', offLabel = 'Draft', disabled = false }) {
  return (
    <label className={`toggle-switch${disabled ? ' disabled' : ''}`}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={e => onChange(e.target.checked)} />
      <span className="toggle-switch-track"><span className="toggle-switch-thumb" /></span>
      <span className={`toggle-switch-label${checked ? ' on' : ''}`}>{checked ? onLabel : offLabel}</span>
    </label>
  );
}
